/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';

import type { MatchDataBlock } from '@swf/generated/cms/types/ContentArea';

import { TXTCLI_Preview, TXTCLI_Report_3 } from './CMSMatch.messages.json';
import MatchDetails from './components/MatchDetails/MatchDetails';
import MatchGrid from './components/MatchGrid/MatchGrid';

const CMSMatch: React.FC<MatchDataBlock> = ({ match_data: { type, reference, info_type } }) =>
  type === 'Grid' ? (
    <MatchGrid
      dataRef={reference}
      previewTranslation={TXTCLI_Preview}
      reportTranslation={TXTCLI_Report_3}
    />
  ) : (
    <MatchDetails
      dataType={info_type}
      dataRef={reference}
      previewTranslation={TXTCLI_Preview}
      reportTranslation={TXTCLI_Report_3}
    />
  );

export default CMSMatch;
